import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import { useFeature } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Paragraph } from '@treams/treams-ui';

import TalentReviewProgressPie from './TalentReviewProgressPie';

export default function TalentReviewProgress(props: {
	review: graphql.TalentReview;
	placements: graphql.TalentReviewPlacement[];
}) {
	const { t } = useTranslation();

	const hideOwnerInTalentReview = useFeature(graphql.FeatureName.HideOwnerInTalentReview);

	const numberOfMembers = props.review.group.members.edges.filter(
		({ role }) => role.type !== graphql.RoleType.Owner || !hideOwnerInTalentReview,
	).length;

	const progress = props.placements.length / numberOfMembers;

	const size = props.review.template.xAxis.ticks.length * props.review.template.yAxis.ticks.length;

	return (
		<Flex alignItems="center">
			<Box mr={2}>
				<Paragraph>{t('talentReviews.edit.progress.instruction', { size })}</Paragraph>
			</Box>
			<Box mr={2} flexGrow={0} flexShrink={0}>
				<TalentReviewProgressPie progress={progress} />
			</Box>
		</Flex>
	);
}
